import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import _get from 'lodash/get';
import {
  RECEIVED,
  BUILDING,
  READY,
  DELIVERED,
  INPROGRESS,
  NOTSTARTED,
  COMPLETED,
  PREPARING,
  ONTHEWAY,
  NOTYETSTARTED,
  REFRESHED,
} from '../constants/App';
import { ternaryCheck } from '../Utils/WindowUtils';

export const getParamFromURL = (cartId: string) => {
  const url = window.location.href.toLowerCase();
  const urlParams = new URL(url);
  return urlParams.searchParams.get(cartId);
};

export const updateAriaLive = (message: string) => {
  const ariaLiveElement = document.getElementById('ariaLive');
  if (ariaLiveElement) {
    ariaLiveElement.innerText = message;
  }
};

export const deliveryProgressStatus = (deliveryStatus: any, progressInfoState: any, setProgressInfo: any, orderDetailStatus: any) => {
  const receivedStatus = _isEmpty(deliveryStatus) || _isEqual(deliveryStatus, RECEIVED);
  if (receivedStatus) {
    const updateReceivedStatus = progressInfoState.progressBars.map(
      (item: { id: string; status: string }) => {
        if (item.id == RECEIVED) item.status = INPROGRESS;
        if (item.id == BUILDING) item.status = NOTSTARTED;
        if (item.id == READY) item.status = NOTSTARTED;
        if (item.id == DELIVERED) item.status = NOTSTARTED;
        return item;
      },
    );
    setProgressInfo({ ...progressInfoState, isCompleted: false, isRotate: false, orderDetailStatus: orderDetailStatus?.[0], progressBars: [...updateReceivedStatus] });
  }
  if (_isEqual(deliveryStatus, PREPARING)) {
    const updatePreparing = progressInfoState.progressBars.map(
      (item: { id: string; status: string }) => {
        if (item.id == RECEIVED) item.status = COMPLETED;
        if (item.id == BUILDING) item.status = INPROGRESS;
        if (item.id == READY) item.status = NOTSTARTED;
        if (item.id == DELIVERED) item.status = NOTSTARTED;
        return item;
      },
    );
    setProgressInfo({ ...progressInfoState, isCompleted: false, isRotate: false, orderDetailStatus: orderDetailStatus?.[1], progressBars: [...updatePreparing] });
  }
  if (_isEqual(deliveryStatus, ONTHEWAY)) {
    const updateOntheway = progressInfoState.progressBars.map(
      (item: { id: string; status: string }) => {
        if (item.id == RECEIVED) item.status = COMPLETED;
        if (item.id == BUILDING) item.status = COMPLETED;
        if (item.id == READY) item.status = INPROGRESS;
        if (item.id == DELIVERED) item.status = NOTSTARTED;
        return item;
      },
    );
    setProgressInfo({ ...progressInfoState, isCompleted: false, isRotate: false, orderDetailStatus: orderDetailStatus?.[2], progressBars: [...updateOntheway] });
  }
  if (_isEqual(deliveryStatus, DELIVERED)) {
    const updateDelivered = progressInfoState.progressBars.map(
      (item: { id: string; status: string }) => {
        if (item.id == RECEIVED) item.status = COMPLETED;
        if (item.id == BUILDING) item.status = COMPLETED;
        if (item.id == READY) item.status = COMPLETED;
        if (item.id == DELIVERED) item.status = INPROGRESS;
        return item;
      },
    );
    setProgressInfo({ ...progressInfoState, isCompleted: true, isRotate: false, orderDetailStatus: orderDetailStatus?.[3], progressBars: [...updateDelivered] });
  }
  if (_isEqual(deliveryStatus, 'cancelled')) {
    setProgressInfo({ ...progressInfoState, isCompleted: false, isRotate: false, orderDetailStatus: null, isCancelled: true });
  }
}

export const updateProgressBars = async (
  data: any,
  progressInfoState: any,
  setProgressInfo: any,
  deliveryData?: any,
) => {
  if (!_isEmpty(_get(data, 'orderConfirmationStatusData'))) {
    const deliveryDetails = _get(data, ['orderConfirmationStatusData', 'deliveryDetails']);
    const orderStatusDetail = _get(data, ['orderConfirmationStatusData', 'orderDetailStatus'], null);
    if (!_isEmpty(deliveryDetails)) {
      deliveryData
        .postRequest({
          cartId: getParamFromURL('cartid'),
          siteName: deliveryData.siteName,
          apiEndpoint: _get(data, ['apis', 'updateDeliveryOrderStatusApi']),
        })
        .then((res: any) => {
          updateAriaLive(_get(data, ['dictionaryLablesAll', 'refreshed'], REFRESHED))
          const { deliveryStatus } = res;
          deliveryProgressStatus(deliveryStatus, progressInfoState, setProgressInfo, orderStatusDetail)
        });
      return;
    }

    if (_get(document.getElementById('is-status-expire'), ['value']) == 1) {
      setProgressInfo({ ...progressInfoState, isRotate: false, isCompleted: false, orderDetailStatus: null, isStatusExpire: 1 });
    }

    // FIXED: Check if order is for future date - don't progress if it's a future order
    const isFutureOrderDate = _get(data, ['orderConfirmationStatusData', 'isFutureOrderDate'], false);
    if (isFutureOrderDate) {
      // For future orders, just set the initial state without any progress
      const initialProgressState = progressInfoState.progressBars.map(
        (item: { id: string; status: string }) => {
          if (item.id == RECEIVED) item.status = INPROGRESS;
          if (item.id == BUILDING) item.status = NOTSTARTED;
          if (item.id == READY) item.status = NOTSTARTED;
          return item;
        },
      );
      setProgressInfo({
        ...progressInfoState,
        isCompleted: false,
        isRotate: false,
        orderDetailStatus: orderStatusDetail?.[0], 
        progressBars: [...initialProgressState]
      });
      return;
    }
    const offestTime: string = _get(data, ['orderConfirmationStatusData', 'storeOffset'], null);
    const { totalCurrentMinutes } = getTotalCurrentUTCTime(offestTime);
    const pickupTime = _get(data, ['orderConfirmationStatusData', 'pickupTime']);
    const curbSidePickUpTimeExceededMins = _get(data, [
      'orderConfirmationStatusData',
      'curbSidePickUpTimeExceededMins',
    ]);
    const pickupMinutes = getPickupTimeInMinutes(
      offestTime,
      pickupTime,
      curbSidePickUpTimeExceededMins,
    );
    const midTimeMinuts =
      pickupMinutes -
      parseInt(_get(data, ['orderConfirmationStatusData', 'curbSideStatusBarProgressMins']));
    const expireTimeInMins = pickupMinutes + parseInt(curbSidePickUpTimeExceededMins);
let adjustedPickupMinutes = pickupMinutes;
    let adjustedMidTimeMinuts = midTimeMinuts;
    let adjustedExpireTimeInMins = expireTimeInMins;
    if (pickupMinutes < totalCurrentMinutes) {
      adjustedPickupMinutes += 1440;
      adjustedMidTimeMinuts += 1440;
      adjustedExpireTimeInMins += 1440;
    }
    const alreadySuccessApi = !_get(data, ['orderConfirmationStatusData', 'posNotify'], null);

    if (alreadySuccessApi && !_isEmpty(progressInfoState?.progressBars)) {
      if (totalCurrentMinutes < adjustedMidTimeMinuts) {
        const updateMidTimeMinuts = progressInfoState.progressBars.map(
          (item: { id: string; status: string }) => {
            if (item.id == RECEIVED) item.status = INPROGRESS;
            if (item.id == BUILDING) item.status = NOTSTARTED;
            if (item.id == READY) item.status = NOTSTARTED;
            return item;
          },
        );
        setProgressInfo({ ...progressInfoState, isCompleted: false, isRotate: false, orderDetailStatus: orderStatusDetail?.[0], progressBars: [...updateMidTimeMinuts] });
      } else if (totalCurrentMinutes >= adjustedMidTimeMinuts && totalCurrentMinutes < adjustedPickupMinutes) {
        const updatePickupMinutes = progressInfoState.progressBars.map(
          (item: { id: string; status: string }) => {
            if (item.id == RECEIVED) item.status = COMPLETED;
            if (item.id == BUILDING) item.status = INPROGRESS;
            if (item.id == READY) item.status = NOTSTARTED;
            return item;
          },
        );
        setProgressInfo({ ...progressInfoState, isCompleted: false, isRotate: false, orderDetailStatus: orderStatusDetail?.[1], progressBars: [...updatePickupMinutes] });
      } else if (totalCurrentMinutes >= adjustedPickupMinutes && totalCurrentMinutes <= adjustedExpireTimeInMins) {
        const updateExpireTimeInMins = progressInfoState.progressBars.map(
          (item: { id: string; status: string }) => {
            if (item.id == RECEIVED) item.status = COMPLETED;
            if (item.id == BUILDING) item.status = COMPLETED;
            if (item.id == READY) item.status = INPROGRESS;
            return item;
          },
        );
        setProgressInfo({ ...progressInfoState, isCompleted: true, isRotate: false, orderDetailStatus: orderStatusDetail?.[2], progressBars: [...updateExpireTimeInMins] });
      } else if (totalCurrentMinutes > adjustedExpireTimeInMins) {
        setProgressInfo({ ...progressInfoState, isRotate: false, isCompleted: false, orderDetailStatus: null, isStatusExpire: 1 });
      }
    }
  }
};

export const imHereHandler = (
  apiData: any,
  setEarlyModal: any,
  setReadyModal: any,
) => {
  const offestTime: any = _get(apiData, ['orderConfirmationStatusData', 'storeOffset'], null);
  if (!_isEmpty(offestTime)) {
    const { totalCurrentMinutes } = getTotalCurrentUTCTime(offestTime);
    const pickupTime = _get(apiData, ['orderConfirmationStatusData', 'pickupTime']);
    const curbSidePickUpTimeExceededMins = _get(apiData, [
      'orderConfirmationStatusData',
      'curbSidePickUpTimeExceededMins',
    ]);
    const pickupMinutes = getPickupTimeInMinutes(
      offestTime,
      pickupTime,
      curbSidePickUpTimeExceededMins,
    );
    const midTimeMinuts =
      pickupMinutes -
      parseInt(_get(apiData, ['orderConfirmationStatusData', 'curbSideStatusBarProgressMins']));
    const expireTimeInMins = pickupMinutes + parseInt(curbSidePickUpTimeExceededMins);
    const reachedModalTimeMinuts =
      pickupMinutes -
      parseInt(_get(apiData, ['orderConfirmationStatusData', 'curbSideWhoaThereModalMins']));

    if (totalCurrentMinutes < midTimeMinuts && totalCurrentMinutes < reachedModalTimeMinuts) {
      setEarlyModal(true);
    }
    if (
      totalCurrentMinutes >= midTimeMinuts &&
      totalCurrentMinutes < pickupMinutes &&
      totalCurrentMinutes < reachedModalTimeMinuts
    ) {
      setEarlyModal(true);
    }
    if (totalCurrentMinutes >= pickupMinutes && totalCurrentMinutes <= expireTimeInMins) {
      setEarlyModal(false);
      setReadyModal(true);
    }
    if (totalCurrentMinutes <= pickupMinutes && totalCurrentMinutes >= reachedModalTimeMinuts) {
      setEarlyModal(false);
      setReadyModal(true);
    }
  }
};

export const getOffsetInMinutes = (offsetTime: any) => {
  const [hours, minutes] = offsetTime?.substring(1).split(':');
  const offsetSign = offsetTime[0] === '-' ? -1 : 1;
  return offsetSign * (parseInt(hours) * 60 + parseInt(minutes));
};

export const convertToMinutes = (time: string) => {
  const [hours, minutes] = time.split(':');
  return parseInt(hours) * 60 + parseInt(minutes);
};

export const getPickupTimeInMinutes = (
  offsetTime: string,
  pickupTime: string,
  curbSidePickUpTimeExceededMins: string,
) => {
  const { totalCurrentMinutes, hours } = getTotalCurrentUTCTime(offsetTime);
  let [pickupHours, pickupMinutes]: (number | string)[] = pickupTime?.split(':');
  pickupMinutes = parseInt(pickupMinutes);
  pickupHours = parseInt(pickupHours);
  let pickupTimeInMinutes = pickupHours * 60 + pickupMinutes;

  if (
    hours > pickupHours &&
    pickupTimeInMinutes + parseInt(curbSidePickUpTimeExceededMins) < totalCurrentMinutes
  ) {
    pickupHours = pickupHours + 12;
    pickupTimeInMinutes = pickupHours * 60 + pickupMinutes;
  }
  return pickupTimeInMinutes;
};

export const getTotalCurrentUTCTime = (offestTime: string) => {
  const offsetHour: number = parseInt(offestTime?.split(':')[0]);
  const modifiedOffestTime = offsetHour > 0 ? `+${offestTime}` : offestTime;
  const currentDate = new Date();
  currentDate.setUTCMinutes(currentDate.getUTCMinutes() + getOffsetInMinutes(modifiedOffestTime));
  let hours = currentDate.getUTCHours();
  hours = hours == 0 ? 12 : hours;
  const minutes = currentDate.getUTCMinutes();
  return {
    hours: hours,
    totalCurrentMinutes: hours * 60 + minutes,
  };
};

export const redirectToSignupPage = (languageCode: string, response?: string) => {
  const currentURL = window.location.href;
  const destinationURL = !_isEmpty(response)
    ? `/${languageCode}/auth/SignUpInvitation?url=${currentURL}&invitation=${response}`
    : `/${languageCode}/auth/SignUp`;
  window.location.href = destinationURL;
};

export const getStatusAriaLabel = (status: string, label: string) => {
  if (_isEqual(status, NOTSTARTED)) {
    return `${label} ${NOTYETSTARTED}`;
  }
  if (_isEqual(status, INPROGRESS)) {
    return `${label} ${INPROGRESS}`;
  }
  if (_isEqual(status, COMPLETED)) {
    return `${label} ${COMPLETED}`;
  }
};

export const getOrderType = (isRecentOrderPage?: boolean, isLocatorPage?: boolean) => {
  if (isRecentOrderPage) {
    return 'Re-Order';
  } else {
    return isLocatorPage ? '' : 'favorite';
  }
}
export const addToCartItems = (
  quantity: number,
  itemDetails: any,
  masterProductId: string | null,
  options: any[] = [],
  offerId: string | null = null,
) => {
  const {
    productName,
    name,
    upsellCategoryId,
    productId,
    productOriginSource,
    categoryName,
    categoryId,
    subCategory,
    isCookie,
    upSellBaseProduct,
    promotionTypeName
  } = itemDetails;
  const analyticsProductName = ternaryCheck(isCookie, _get(options, ['0', 'optionName'], ''), productName)
  return {
    AddCartItems: [
      {
        analytics: {
          CategoryId: categoryId || upsellCategoryId,
          CategoryName: categoryName ?? promotionTypeName,
          ProductName: analyticsProductName || name,
          ProductOriginSource: productOriginSource,
          offerId: offerId,
          masterProductId: masterProductId,
          subCategory: subCategory,
          isCookie: isCookie,
          upSellBaseProduct: upSellBaseProduct,
        },
        options: options,
        productId: productId,
        productName: productName || name,
        quantity: quantity,
        imageUrl: '',
      },
    ],
  };
};
